var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indexPage footerPosition"},[_c('div',{staticClass:"pageTipMar"},[_c('p',[_c('img',{staticStyle:{"width":"36px","height":"36px"},attrs:{"src":require("../../../assets/img/loading.gif")}})]),_vm._v(" "),_c('p')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20cc99d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reception/otherPage/printPage.vue
// module id = null
// module chunks = 